export default __webpack_public_path__ + "static/media/smile.98dae336.svg";